<template>
  <form
    autocomplete="off"
    method="post"
    action=""
    class="flex w-full items-center justify-center gap-1 sm:gap-2"
  >
    <input
      autocomplete="false"
      name="hidden"
      type="text"
      style="display: none"
    />
    <input
      type="number"
      v-for="(item, index) in inputValues"
      class="border-ontick-steel-300 !ring-ontick-blue-600 dark:bg-ontick-carbon-500 dark:border-ontick-steel-500 flex h-10 w-10 items-center justify-center rounded text-center shadow focus:outline-none focus:ring-2"
      :ref="`pincodeinput${index}`"
      :key="index"
      :value="item.value"
      @input.prevent="handleInput(index, $event)"
      @keydown.delete.prevent="handleDelete(index, $event)"
      @focus="select(index)"
      maxlength="1"
    />
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    type: {
      type: String,
      default: "number",
      validator: (val) => {
        return ["text", "number"].includes(val);
      },
    },
    codelength: {
      type: Number,
      default: 4,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      inputValues: [],
      activeIndex: 0,
    };
  },

  computed: {
    returnValue() {
      return this.inputValues.map((item) => item.value).join("");
    },
  },

  methods: {
    setFocus(index) {
      this.$refs[`pincodeinput${index}`][0].focus();
      this.$refs[`pincodeinput${index}`][0].select();
    },
    select(index) {
      this.$refs[`pincodeinput${index}`][0].select();
    },
    handleInput(index, event) {
      const value = event.target.value;
      if (value) {
        this.inputValues[index].value = value;
        if (index < this.codelength - 1) {
          this.setFocus(index + 1);
        }
      }
    },
    handleDelete(index, event) {
      const value = event.target.value;

      if (value) {
        this.inputValues[index].value = null;
      } else if (index > 0) {
        this.setFocus(index - 1);
        this.inputValues[index - 1].value = null;
      }
    },
  },

  watch: {
    returnValue: {
      handler(val) {
        this.$emit("input", val);
      },
    },
  },

  created() {
    for (let i = 0; i < this.codelength; i++) {
      this.inputValues.push({ value: null });
    }
  },

  mounted() {
    if (this.autofocus) {
      this.$refs.pincodeinput0[0].focus();
    }
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
